module.exports = __webpack_public_path__ + "img/power-level-5.7e0159ff.png";